<template>
  <v-ons-page>

    <v-ons-toolbar class="toolbar--noshadow toolbar--noborder" modifier="perfhome">
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        Prix OS - {{ cultLabel }}
      </div>
    </v-ons-toolbar>

    <div class="content content--perfonglet">

      <img :src="negoceImg + '.png'" :srcset="negoceImg + '@2x.png 2x'" class="perfnegoce" />

      <app-error-msg :list="errorMsgList"></app-error-msg>

      <v-ons-list-title modifier="perflist">
        Afin de sélectionner vos prix «{{ cultLabel }}» veuillez nous indiquer&nbsp;:
      </v-ons-list-title>

      <v-ons-list v-for="(configItem, configId) in configList" modifier="noborder perflist"
                  :key="'list-' + configId">

        <v-ons-list-item modifier="nodivider"
                         :class="{ 'label--invalid': errorMsgList['input-' + configId] !== undefined }">
          <div class="center">
            <span>
              <template v-for="(ligneItem, ligneIndex) in configItem.libelle_eval">
                {{ ligneItem.replace(/ ?(\?|:)$/, '&nbsp;$1') }}
                <br :key="ligneIndex"/>
              </template>
              <i v-if="! configItem.is_required">Optionnel</i>
            </span>
          </div>
        </v-ons-list-item>

        <template v-if="configItem.input_type == 'checkbox'">

          <v-ons-list-item v-for="(choixItem, choixIndex) in configItem.choix"
                           modifier="nodivider perfradio" :key="choixIndex"
                           tappable :ref="'input-' + configId">
            <div class="left">
              <v-ons-checkbox modifier="material" :input-id="'checkbox-' + configId + '-' + choixIndex"
                              :value="choixItem.id" v-model="userConfig[configId]">
              </v-ons-checkbox>
            </div>
            <label class="center" :for="'checkbox-' + configId + '-' + choixIndex">
              {{ choixItem.label }}
            </label>
          </v-ons-list-item>

        </template>

        <template v-else-if="configItem.input_type == 'radio'">

          <v-ons-list-item v-for="(choixItem, choixIndex) in configItem.choix"
                           modifier="nodivider perfradio" :key="choixIndex"
                           tappable :ref="'input-' + configId">
            <div class="left">
              <v-ons-radio modifier="material" :input-id="'radio-' + configId + '-' + choixIndex"
                              :value="choixItem.id" v-model="userConfig[configId]">
              </v-ons-radio>
            </div>
            <label class="center" :for="'radio-' + configId + '-' + choixIndex">
              {{ choixItem.label }}
            </label>
          </v-ons-list-item>

        </template>

        <template v-else-if="configItem.input_type == 'number'">

          <app-input :input-id="'input-' + configId" :ref="'input-' + configId"
                      input-type="number" v-model.number="userConfig[configId]"
                      :input-step="configItem.input_step ? configItem.input_step : 1"
                      :placeholder="configItem.placeholder"></app-input>

        </template>

      </v-ons-list>

      <footer class="footer--perfbutton">
        <v-ons-button modifier="large--cta perflarge" @click="saveConfig">
          Enregistrer
          <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
        </v-ons-button>
      </footer>

    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from '../store.js';

import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppLabel from '../partials/Label.vue';
import AppInput from '../partials/Input.vue';

export default {
  mixins: [mixinsCommons, mixinsCours],
  components: { AppErrorMsg, AppLabel, AppInput },
  props: ['pageStack'],
  data() {
    return {
      negoceId: '',
      refCulture: '',
      refDestination: '',
      configList: {},
      userConfig: {},
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    referentiel() {
      return this.data.referentiel;
    },
    cultLabel(){
      return this.getCultLabel();
    },
    negoceInfos() {
      return this.getNegoceAcces(this.data.negoce.list, this.negoceId);
    },
    config() {
      return this.negoceInfos.config;
    }
  },
  watch: {
    userConfig: {
      deep: true,
      handler() {
        this.setConfigList();
      }
    }
  },
  methods: {
    setConfigList() {
      var userConfig = {};
      if(this.user.ventes[this.refCulture][this.refDestination].config
      && this.user.ventes[this.refCulture][this.refDestination].config[this.negoceId]){
        var userConfig = this.user.ventes[this.refCulture][this.refDestination].config[this.negoceId];
      }
      this.configList = {};
      for (let i = 0; i < this.config.length; i++) {
        var configItem = this.config[i];
        if (configItem.campagne && configItem.campagne != this.campagne) {
          continue;
        }
        if (configItem.refCulture && configItem.refCulture != this.refCulture) {
          continue;
        }
        if (configItem.refDestination && configItem.refDestination != this.refDestination) {
          continue;
        }
        if (configItem.if) {
          var isMatch = true;
          for (const id in configItem.if) {
            if (Array.isArray(this.userConfig[id])) {
              if (! configItem.if[id].filter(value => this.userConfig[id].includes(value)).length){
                isMatch = false;
              }
            } else {
              if (! configItem.if[id].includes(this.userConfig[id])) {
                isMatch = false;
              }
            }
          }
          if (!isMatch) {
            continue;
          }
        }
        if (! this.userConfig[configItem.id]) {
          if (configItem.input_type == 'checkbox') {
            this.$set(this.userConfig, configItem.id, userConfig[configItem.id] ? userConfig[configItem.id] : []);
          } else if (configItem.input_type == 'number' || configItem.input_type == 'radio') {
            this.$set(this.userConfig, configItem.id, userConfig[configItem.id] ? userConfig[configItem.id] : '');
          }
        }
        configItem.libelle_eval = configItem.libelle
        let evalExpr = configItem.libelle_eval.match(/{{ [^}]* }}/g);
        if(evalExpr){
          for (let j = 0; j < evalExpr.length; j++) {
            let evalOutput = evalExpr[j];
            evalOutput = evalOutput.replace(/ ([a-z_]+) /g, ' this.userConfig.$1 ');
            evalOutput = eval(evalOutput);
            configItem.libelle_eval = configItem.libelle_eval.replace(/{{ [^}]* }}/, evalOutput);
          }
        }
        configItem.libelle_eval = configItem.libelle_eval.split("\n");
        this.$set(this.configList, configItem.id, configItem);
      }
    },
    async saveConfig() {
      if (this.isSubmit) {
        return;
      }
      this.resetErrorMsgList();

      const userConfig = {};
      for (const configId in this.configList) {
        const configItem = this.configList[configId];
        if (configItem.is_required) {

          let isValid = true;
          if (Array.isArray(this.userConfig[configId])) {
            if(! this.userConfig[configId].length){
              isValid = false;
            }
          } else {
            if(this.userConfig[configId] === ''){
              isValid = false;
            }
          }

          if (! isValid) {
            var msg = "Certaines informations sont obligatoires";
            if (Object.keys(this.errorMsgList).length) {
              msg = '';
            }
            this.setErrorMsgList('input-' + configId, msg);
          }
        }

        userConfig[configId] = this.userConfig[configId];
      }

      if (Object.keys(this.errorMsgList).length) {
        this.$scrollTop();
        return;
      }

      this.isSubmit = true;

      const body = {
        id: this.user.id,
        date: this.user.date,
        ref_culture: this.refCulture,
        ref_destination: this.refDestination,
        id_negoce: this.negoceId,
        data: userConfig
      };

      const fetchInit = this.$getFetchInit();
      fetchInit.body = JSON.stringify(body);
      const callPath = this.$apiDomain + this.getPath('/negoce/config');
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        this.updateUserFromResponse(response.user);
        
        store.data.negoce = response.negoce;
        this.ionicStorage.set('negoce', response.negoce);

        this.pageStack.length > 1 && this.pageStack.pop();
      } catch(error) {
          this.handleError(error);
      }
    }
  },
  created() {
    this.setConfigList();
  }
}
</script>

<style>
</style>